module.exports = __webpack_public_path__ + "media/landing_page/city-page-hero-mobile-d353dc3c.jpg";